// extracted by mini-css-extract-plugin
export default {"container":"ApplicationsList__container-lfCAS","appsList":"ApplicationsList__appsList-wKp84","appIcon":"ApplicationsList__appIcon-oiPIx","appName":"ApplicationsList__appName-fXy6J"};